// URLs for lucide-static icons
const successIconUrl = 'https://cdn.jsdelivr.net/npm/lucide-static@latest/icons/check-circle.svg';
const failureIconUrl = 'https://cdn.jsdelivr.net/npm/lucide-static@latest/icons/x-circle.svg';
const infoIconUrl = 'https://cdn.jsdelivr.net/npm/lucide-static@latest/icons/info.svg';
export function InitializeNotification(boxId) {
    const notificationBox = document.getElementById(boxId);
    const notificationIcon = notificationBox.querySelector('#notification-icon');
    const notificationMessage = notificationBox.querySelector('#notification-message');
    const notificationTimeoutId = null;
    const hideNotificationCB = null;
    return { notificationBox, notificationIcon, notificationMessage, notificationTimeoutId, hideNotificationCB };
}
/**
 * Hides the notification box with animation.
 */
export function HideNotification(box) {
    const { notificationBox, notificationTimeoutId } = box;
    if (notificationTimeoutId) {
        clearTimeout(notificationTimeoutId); // Clear existing timer
        box.notificationTimeoutId = null;
    }
    notificationBox.classList.add('opacity-0', '-translate-y-full');
    notificationBox.classList.remove('opacity-100', 'translate-y-0');
    // Remove the click listener after hiding
    notificationBox.removeEventListener('click', box.hideNotificationCB);
}
/**
 * Shows the notification box with a message and type (success/failure).
 * @param {string} message - The message to display.
 * @param {'success' | 'failure'} type - The type of notification.
 */
export function ShowNotification(box, message, type) {
    const { notificationBox, notificationIcon, notificationMessage, notificationTimeoutId } = box;
    // Clear any existing timeout to prevent overlap
    if (notificationTimeoutId) {
        clearTimeout(notificationTimeoutId);
    }
    // Set message content
    notificationMessage.textContent = message;
    // Reset styles
    notificationBox.classList.remove('bg-green-100', 'text-green-800', 'border-green-300', 'bg-red-100', 'text-red-800', 'border-red-300');
    notificationIcon.classList.remove('text-green-500', 'text-red-500'); // Remove potential text color if using font icons
    // Apply type-specific styles and icon
    const icon = (notificationIcon);
    if (type === 'success') {
        icon.src = successIconUrl;
        notificationBox.classList.add('bg-green-100', 'text-green-800', 'border-green-300');
        // Optional: If you want the SVG icon itself colored
        icon.classList.add('text-green-500'); // Requires SVG manipulation or specific CSS
    }
    else if (type === 'failure') {
        icon.src = failureIconUrl;
        notificationBox.classList.add('bg-red-100', 'text-red-800', 'border-red-300');
        // Optional: If you want the SVG icon itself colored
        icon.classList.add('text-red-500');
    }
    else {
        // Default or neutral style (optional)
        icon.src = infoIconUrl; // Example neutral icon
        notificationBox.classList.add('bg-blue-100', 'text-blue-800', 'border-blue-300');
    }
    // Make the notification visible with animation
    notificationBox.classList.remove('opacity-0', '-translate-y-full');
    notificationBox.classList.add('opacity-100', 'translate-y-0');
    // Add click listener to hide the notification
    box.hideNotificationCB = () => HideNotification(box);
    notificationBox.addEventListener('click', box.hideNotificationCB);
    // Set timeout to hide the notification automatically after 2 seconds
    box.notificationTimeoutId = setTimeout(box.hideNotificationCB, 2000);
}
